"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var JETContextMenuItemType;
(function (JETContextMenuItemType) {
    JETContextMenuItemType["Header"] = "Header";
    JETContextMenuItemType["Menu"] = "Menu";
    JETContextMenuItemType["Button"] = "Button";
    JETContextMenuItemType["Separator"] = "Separator";
    JETContextMenuItemType["System"] = "System";
})(JETContextMenuItemType = exports.JETContextMenuItemType || (exports.JETContextMenuItemType = {}));



//////////////////
// WEBPACK FOOTER
// /app/~/redi-window-container-web-lib/dist/infrastructure/jet.js
// module id = 40
// module chunks = 0